// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/js/views/user/index.css
// module id = 2025
// module chunks = 0